module.exports = __webpack_public_path__ + "03_mole.85bb3726.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer2/03_mole.png
// module id = NWfL
// module chunks = 0